module.exports = __webpack_public_path__ + "img/Sistemas-MBD-Informatica.915f9d59.jpg";